// extracted by mini-css-extract-plugin
export default {"employee-or-organization-title":"CheckoutDetails_employee-or-organization-title__COTOH"};